import ReactPlayer from './ReactPlayer.client'
import Image from './Image'
import VideoPlaceholder from '#images/video-placeholder.jpg'
import VideoPlaceholderDark from '#images/video-placeholder-dark.jpg'
import { Theme, useTheme } from '#app/utils/providers/themeProvider'
import { ClientOnly } from 'remix-utils/client-only'
import Skeleton from 'react-loading-skeleton'
import { NFTCache } from '#types/loreTypes'
import { useState } from 'react'

export default function Video({ nft }: { nft: NFTCache }) {
	const [theme] = useTheme()

	return (
		<ClientOnly
			fallback={
				<div className="relative left-0 top-0 h-full w-full object-contain">
					<Skeleton
						baseColor={
							theme === 'light' || theme === undefined ? '#f5f5f5' : '#383838'
						}
						highlightColor={
							theme === 'light' || theme === undefined ? '#f8f8f8' : '#212121'
						}
						borderRadius={'0'}
						inline={true}
						height={'100%'}
						className="absolute mt-0 h-full w-full rounded-none pt-0"
						containerClassName="relative h-full w-full"
					/>
					{/* <div className="absolute top-0 left-0 h-full w-full justify-center items-center">
                    <TypographyLabel additionalClasses="flex-1">FETCHING VIDEO</TypographyLabel>
                </div> */}
				</div>
			}
		>
			{() => {
				return <ClientReactPlayer nft={nft} theme={theme} />
			}}
		</ClientOnly>
	)
}

const ClientReactPlayer = ({
	nft,
	theme,
}: {
	nft: NFTCache
	theme: Theme | undefined
}) => {
	const [hasError, setHasError] = useState(false)

	const getVideoURL = () => {
		if (nft.video_url) {
			return nft.video_url
		} else if (nft.image && typeof nft.image !== 'string') {
			return nft.image.originalUrl
		} else {
			return theme === 'dark' ? VideoPlaceholderDark : VideoPlaceholder
		}
	}

	if (hasError) {
		return (
			<Image
				className="absolute left-0 top-0 h-full w-full object-contain"
				imageUrl={theme === 'dark' ? VideoPlaceholderDark : VideoPlaceholder}
				imageAlt={nft.name}
			></Image>
		)
	} else {
		return (
			<ReactPlayer
				url={getVideoURL()}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					height: '100%',
					width: '100%',
					objectFit: 'contain',
				}}
				controls={true}
				loop={true}
				width={'100%'}
				height={'100%'}
				onError={e => {
					setHasError(true)
				}}
				fallback={
					<div className="relative left-0 top-0 h-full w-full object-contain">
						<Skeleton
							baseColor={
								theme === 'light' || theme === undefined ? '#f5f5f5' : '#383838'
							}
							highlightColor={
								theme === 'light' || theme === undefined ? '#f8f8f8' : '#212121'
							}
							borderRadius={'0'}
							inline={true}
							height={'100%'}
							className="absolute mt-0 h-full w-full rounded-none pt-0"
							containerClassName="absolute h-full w-full"
						/>
						{/* <div className="absolute top-0 left-0 h-full w-full">
                            <TypographyLabel additionalClasses="h-full w-full flex justify-center items-center text-textPrimaryLight dark:text-textPrimaryDark">{progress}%</TypographyLabel>
                        </div> */}
					</div>
				}
			/>
		)
	}
}

export const MediaAttestationVideo = ({
	videoUrl,
	title,
}: {
	videoUrl: string
	title: string
}) => {
	const [theme] = useTheme()

	return (
		<ClientOnly
			fallback={
				<div className="relative left-0 top-0 h-full w-full object-contain">
					<Skeleton
						baseColor={
							theme === 'light' || theme === undefined ? '#f5f5f5' : '#383838'
						}
						highlightColor={
							theme === 'light' || theme === undefined ? '#f8f8f8' : '#212121'
						}
						borderRadius={'0'}
						inline={true}
						height={'100%'}
						className="absolute mt-0 h-full w-full rounded-none pt-0"
						containerClassName="relative h-full w-full"
					/>
					{/* <div className="absolute top-0 left-0 h-full w-full justify-center items-center">
                    <TypographyLabel additionalClasses="flex-1">FETCHING VIDEO</TypographyLabel>
                </div> */}
				</div>
			}
		>
			{() => {
				return (
					<ClientReactPlayerMediaAttestation
						videoUrl={videoUrl}
						name={title}
						theme={theme}
					/>
				)
			}}
		</ClientOnly>
	)
}

const ClientReactPlayerMediaAttestation = ({
	videoUrl,
	name,
	theme,
}: {
	videoUrl: string
	name: string
	theme: Theme | undefined
}) => {
	const [hasError, setHasError] = useState(false)

	if (hasError) {
		return (
			<Image
				className="h-full w-full rounded-lg object-contain"
				imageUrl={theme === 'dark' ? VideoPlaceholderDark : VideoPlaceholder}
				imageAlt={name}
			></Image>
		)
	} else {
		return (
			<ReactPlayer
				url={videoUrl}
				controls={true}
				loop={true}
				width={'100%'}
				height={'100%'}
				onError={e => {
					setHasError(true)
				}}
				fallback={
					<div className="relative left-0 top-0 h-full w-full object-contain">
						<Skeleton
							baseColor={
								theme === 'light' || theme === undefined ? '#f5f5f5' : '#383838'
							}
							highlightColor={
								theme === 'light' || theme === undefined ? '#f8f8f8' : '#212121'
							}
							borderRadius={'0'}
							inline={true}
							height={'100%'}
							className="absolute mt-0 h-full w-full rounded-none pt-0"
							containerClassName="absolute h-full w-full"
						/>
						{/* <div className="absolute top-0 left-0 h-full w-full">
                            <TypographyLabel additionalClasses="h-full w-full flex justify-center items-center text-textPrimaryLight dark:text-textPrimaryDark">{progress}%</TypographyLabel>
                        </div> */}
					</div>
				}
			/>
		)
	}
}
